module.exports = __webpack_public_path__ + "static/media/verify.2d922dd3.svg";